import styled from 'styled-components';

export const PageContainer = styled.div`
  display: grid;
  grid-template-columns: 68% 25%;
`;

export const LeftSide = styled.div`
  padding-left: 25px;
  min-width: 829px;
`;

export const RightSide = styled.div`
  padding-left: 25px;
  padding-right: 25px;
  min-width: 351px;
  max-width: 28%;
`;

export const TaskContainer = styled.div`
  margin-top: 40px;
  background-color: white;
`;

export const Header = styled.div``;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 45px 0 45px;
`;

export const TaskName = styled.div`
  font-size: 18px;
  padding: 0 20px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TaskBreadcrumbdiv = styled.div`
  padding: 20px 150px 0px 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 12px;
  color: #8e8e8e;
`;

export const TaskBreadcrumb = styled.span`
  display: inline-block;
  width: 120px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
`;

export const TaskExternalLink = styled.div`
  width: 20%;
  font-size: 14px;
  color: #8e8e8e;
  display: flex;
  justify-content: end;
  align-items: center;

  span {
    font-weight: 300;
    margin-left: 8px;
  }
`;

export const HeaderBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 45px;

  section {
    font-size: 12px;
    color: #8e8e8e;
    margin-bottom: 10px;
  }

  span {
    font-size: 12px;
    color: #8e8e8e;
  }
`;

export const Assignee = styled.div`
  div {
    display: flex;
    align-items: center;
    margin-right: 10px;

    > span {
      font-size: 16px;
      color: #2c2c2c;
    }
  }
`;

export const PlannedCompletionDate = styled.div`
  > span {
    color: #2c2c2c;
    font-size: 16px;
  }
`;

export const Status = styled.div`
  div {
    display: flex;
    align-items: center;
    margin-right: 10px;

    span {
      color: #2c2c2c;
      font-size: 16px;
    }
  }
`;

export const Circle = styled.div`
  width: 8px;
  height: 8px;
  background: #${props => props.color};
  border-radius: 50%;
`;
